import { FileText, ListChecks, Warning } from '@phosphor-icons/react';
import { Flex, UnderlineTab, UnderlineTabs } from '@chatsdet/ui';
import type { ExploratoryTestCandidateVerification } from '../../../features/exploratory-tests/types';
import {
  FuzzPlanPanel,
  FuzzReportPanel,
} from '../../../features/exploratory-tests/components/FuzzRunSummary';
import { IssuesPanel } from './IssuesPanel';
import { PlanPanel } from './PlanPanel';
import { ReportPanel } from './ReportPanel';
import type { ExploratoryTestData, SidebarTab } from './types';

type ExploratoryDetailSidebarProps = {
  activeTab: SidebarTab;
  issuesCount: number;
  test: ExploratoryTestData;
  filedVerifications: ExploratoryTestCandidateVerification[];
  pendingVerifications: ExploratoryTestCandidateVerification[];
  onTabChange: (tab: SidebarTab) => void;
  onOpenIssue: (issueId: string) => void;
};

export function ExploratoryDetailSidebar({
  activeTab,
  issuesCount,
  test,
  filedVerifications,
  pendingVerifications,
  onTabChange,
  onOpenIssue,
}: ExploratoryDetailSidebarProps) {
  const isFuzz = test.flavor === 'fuzz';
  return (
    <div className="w-[380px] shrink-0 flex flex-col border-l border-border bg-card">
      <UnderlineTabs
        selectedId={activeTab}
        onSelectionChange={(id) => onTabChange(id as SidebarTab)}
        className="pt-3"
      >
        <UnderlineTab id="plan" className="flex-1 py-3">
          <Flex align="center" gap="xs" justify="center">
            <ListChecks size={16} weight="bold" />
            Plan
          </Flex>
        </UnderlineTab>
        <UnderlineTab id="report" className="flex-1 py-3">
          <Flex align="center" gap="xs" justify="center">
            <FileText size={16} weight="bold" />
            Report
          </Flex>
        </UnderlineTab>
        <UnderlineTab id="issues" className="flex-1 py-3">
          <Flex align="center" gap="xs" justify="center">
            <Warning size={16} weight="bold" />
            Issues{issuesCount > 0 ? ` (${issuesCount})` : ''}
          </Flex>
        </UnderlineTab>
      </UnderlineTabs>

      <div className="flex-1 min-h-0 overflow-hidden">
        {activeTab === 'plan' &&
          (isFuzz ? <FuzzPlanPanel test={test} /> : <PlanPanel test={test} />)}
        {activeTab === 'report' &&
          (isFuzz ? <FuzzReportPanel test={test} /> : <ReportPanel test={test} />)}
        {activeTab === 'issues' && (
          <IssuesPanel
            filedVerifications={filedVerifications}
            pendingVerifications={pendingVerifications}
            onOpenIssue={onOpenIssue}
          />
        )}
      </div>
    </div>
  );
}
